import { fireDangerIconComponents } from '../../config/fireDanger.config';

const FireDangerIcon = ({ dangerLevel, size = 56 }) => {
  const IconComponent = fireDangerIconComponents[dangerLevel];

  if (!IconComponent) return null;

  return (
    <IconComponent className="fire-danger-icon" size={size} aria-hidden={true} focusable="false" />
  );
};

export default FireDangerIcon;
